// extracted by mini-css-extract-plugin
export default {"container":"ScrollProgressBar_container__1xOpY","bar":"ScrollProgressBar_bar__PxXlM"};